// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidenav {
  height: 100%;
  width: 168px;
  position: fixed;
  top: 55px;
  left: 0;
  background-color: white;
  padding-top: 20px;
  color: black;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1); /* Added box shadow */
  z-index: 500;
}

.sidenav ul {
  list-style-type: none;
  padding: 0;
}

.sidenav li {
  padding: 10px 15px;
}

.sidenav-link {
  color: #131111;
  text-decoration: none;
  display: block;
}

#sidenav saf-menu-item:hover {
  background: rgba(214, 64, 0, 0.1) !important;
  border: 1px solid #d64000 !important;
  color: #d64000 !important;
}
.tablist-container {
  border-bottom: var(--saf-line-width-thick) solid var(--saf-color-line-subtle);
  display: inline-flex;
  gap: var(--saf-space-inline-sm);
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/css/sidenav.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;EACZ,wCAAwC,EAAE,qBAAqB;EAC/D,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,4CAA4C;EAC5C,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,6EAA6E;EAC7E,oBAAoB;EACpB,+BAA+B;EAC/B,WAAW;AACb","sourcesContent":[".sidenav {\n  height: 100%;\n  width: 168px;\n  position: fixed;\n  top: 55px;\n  left: 0;\n  background-color: white;\n  padding-top: 20px;\n  color: black;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1); /* Added box shadow */\n  z-index: 500;\n}\n\n.sidenav ul {\n  list-style-type: none;\n  padding: 0;\n}\n\n.sidenav li {\n  padding: 10px 15px;\n}\n\n.sidenav-link {\n  color: #131111;\n  text-decoration: none;\n  display: block;\n}\n\n#sidenav saf-menu-item:hover {\n  background: rgba(214, 64, 0, 0.1) !important;\n  border: 1px solid #d64000 !important;\n  color: #d64000 !important;\n}\n.tablist-container {\n  border-bottom: var(--saf-line-width-thick) solid var(--saf-color-line-subtle);\n  display: inline-flex;\n  gap: var(--saf-space-inline-sm);\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
